// Configuration for different environments
const config = {
  development: {
    apiBaseUrl: 'http://localhost:3001',
    posthogApiKey: process.env.REACT_APP_POSTHOG_API_KEY || '',
    posthogHost: 'https://us.i.posthog.com'
  },
  production: {
    // Update this URL to your actual deployed backend server
    apiBaseUrl: 'https://civic-duty-mvp-production.up.railway.app',
    posthogApiKey: process.env.REACT_APP_POSTHOG_API_KEY || '',
    posthogHost: 'https://us.i.posthog.com'
  }
};

// Determine current environment
const isDevelopment = process.env.NODE_ENV === 'development' || 
                     window.location.hostname === 'localhost' || 
                     window.location.hostname === '127.0.0.1';

const currentConfig = isDevelopment ? config.development : config.production;

export const API_BASE_URL = currentConfig.apiBaseUrl;

// Helper function to build API URLs
export const buildApiUrl = (endpoint) => {
  return `${API_BASE_URL}${endpoint}`;
};

// PostHog configuration
export const POSTHOG_API_KEY = currentConfig.posthogApiKey;
export const POSTHOG_HOST = currentConfig.posthogHost;

export default config; 